module.exports = "/_next/static/images/72eec4350b92cdeff609d9a91f7866ba-hero-variant-a-desktop.jpg";